<template>
  <unicom-layout-cartao semFiltro>
    <unicom-linha
      key="informacoes"
      style="min-height: 76px"
      justificarItem="start"
    >
      <unicom-coluna sm="12" style="padding-bottom: 24px">
        <div class="titulo negrito cor-fonte fonte-primaria">Leitos</div>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" style="margin:15px 0px;">
        <div class="segunda-cor-fonte">Leitos Total</div>
        <div class="mt-2" style="display: flex">
          <div :style="enumPrestador.estiloTexto">
            {{ objetoInformacoes.leitosTotal }}
          </div>
        </div>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" style="margin:15px 0px;">
        <div class="segunda-cor-fonte">Leitos Contratados</div>
        <div class="mt-2" style="display: flex">
          <div :style="enumPrestador.estiloTexto">
            {{ objetoInformacoes.leitosContratados }}
          </div>
        </div>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" style="margin:15px 0px;">
        <div class="segunda-cor-fonte">Leitos Psiquiatria</div>
        <div class="mt-2" style="display: flex">
          <div :style="enumPrestador.estiloTexto">
            {{ objetoInformacoes.leitosPsiquiatria }}
          </div>
        </div>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" style="margin:15px 0px;">
        <div class="segunda-cor-fonte">Leitos UTI Adulto</div>
        <div class="mt-2" style="display: flex">
          <div :style="enumPrestador.estiloTexto">
            {{ objetoInformacoes.leitosUtiAdulto }}
          </div>
        </div>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" style="margin:15px 0px;">
        <div class="segunda-cor-fonte">Leitos UTI Neonatal</div>
        <div class="mt-2" style="display: flex">
          <div :style="enumPrestador.estiloTexto">
            {{ objetoInformacoes.leitosUtiNeonatal }}
          </div>
        </div>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" style="margin:15px 0px;">
        <div class="segunda-cor-fonte">Leitos UTI Pediatria</div>
        <div class="mt-2" style="display: flex">
          <div :style="enumPrestador.estiloTexto">
            {{ objetoInformacoes.leitosUtiPediatria }}
          </div>
        </div>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" style="margin:15px 0px;">
        <div class="segunda-cor-fonte">Leitos Intermediários</div>
        <div class="mt-2" style="display: flex">
          <div :style="enumPrestador.estiloTexto">
            {{ objetoInformacoes.leitosIntermediarios }}
          </div>
        </div>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" style="margin:15px 0px;">
        <div class="segunda-cor-fonte">Leitos Intermediários Neonatal</div>
        <div class="mt-2" style="display: flex">
          <div :style="enumPrestador.estiloTexto">
            {{ objetoInformacoes.leitosIntermediariosNeonatal }}
          </div>
        </div>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" style="margin:15px 0px;">
        <div class="segunda-cor-fonte">Leitos Hospital Dia</div>
        <div class="mt-2" style="display: flex">
          <div :style="enumPrestador.estiloTexto">
            {{ objetoInformacoes.leitosHospitalDia }}
          </div>
        </div>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" style="margin:15px 0px;">
        <div class="segunda-cor-fonte">Leitos Total Clínicos</div>
        <div class="mt-2" style="display: flex">
          <div :style="enumPrestador.estiloTexto">
            {{ objetoInformacoes.leitosTotalClinicos }}
          </div>
        </div>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" style="margin:15px 0px;">
        <div class="segunda-cor-fonte">Leitos Total Cirúrgicos</div>
        <div class="mt-2" style="display: flex">
          <div :style="enumPrestador.estiloTexto">
            {{ objetoInformacoes.leitosTotalCirurgicos }}
          </div>
        </div>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" style="margin:15px 0px;">
        <div class="segunda-cor-fonte">Leitos Total Obstétricos</div>
        <div class="mt-2" style="display: flex">
          <div :style="enumPrestador.estiloTexto">
            {{ objetoInformacoes.leitosTotalObstetricos }}
          </div>
        </div>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" style="margin:15px 0px;">
        <div class="segunda-cor-fonte">Leitos Total Pediátricos</div>
        <div class="mt-2" style="display: flex">
          <div :style="enumPrestador.estiloTexto">
            {{ objetoInformacoes.leitosTotalPediatricos }}
          </div>
        </div>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" style="margin:15px 0px;">
        <div class="segunda-cor-fonte">Leitos Total Psiquiátricos</div>
        <div class="mt-2" style="display: flex">
          <div :style="enumPrestador.estiloTexto">
            {{ objetoInformacoes.leitosTotalPsiquiatricos }}
          </div>
        </div>
      </unicom-coluna>
    </unicom-linha>
  </unicom-layout-cartao>
</template>

<script>
import PrestadorMixin from "@/views/RecursosPropriosQuestionarios/shared/mixins/questionarios/PrestadorMixin";

export default {
  name: "CartaoInformacoesPrestador",
  mixins: [PrestadorMixin],
  props: {
    objetoInformacoes: {
      type: Object,
      default: () => {
        return {
          leitosTotal: "",
          leitosContratados: "",
          leitosPsiquiatria: "",
          leitosUtiAdulto: "",
          leitosUtiNeonatal: "",
          leitosUtiPediatria: "",
          leitosIntermediarios: "",
          leitosIntermediariosNeonatal: "",
          leitosHospitalDia: "",
          leitosTotalClinicos: "",
          leitosTotalCirurgicos: "",
          leitosTotalObstetricos: "",
          leitosTotalPediatricos: "",
          leitosTotalPsiquiatricos: ""
        };
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {},
  computed: {
    espacamentoMobile() {
      return this.$breakpoint.smAndDown ? "mt-4" : "";
    }
  },
  watch: {}
};
</script>

<style scoped></style>
